export default __webpack_public_path__ + "static/media/logo.79320e20.svg";